import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class EisaScoringRaceRoute extends Route
{
	@service ajax

	async model(params)
	{
		const config = await this.ajax.request("eisaScoringConfig.json");
		const results = await this.fetchAllResults(config);
		const raceIndex = parseInt(params.race_index);
		return { config, results, raceIndex };
	}

	async fetchAllResults(config)
	{
		const filesToFetch = new Set();
		for (const race of config?.nordic?.races || [])
		{
			filesToFetch.add(race.resultsFile);
		}

		const results = {};
		for (const fileName of filesToFetch)
		{
			let data = await this.ajax.request(fileName);
			data = data.map(r => r.data.attributes);
			results[fileName] = data;
		}
		return results;
	}

	setupController(controller, model)
	{
		controller.set('event', this.modelFor('event'));
		controller.set('config', model.config);
		controller.set('results', model.results);
		controller.set('raceIndex', model.raceIndex);
	}
}
